import React from 'react'
import { useParams } from 'react-router'

import { RecordFactory } from '../../models/RecordFactory'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { FieldPage } from './FieldPage'

const viewWillAppear = async ({ urlParams }: PocketComponent<void>) => {
    const field = !!urlParams.fieldID
        ? await RecordFactory.getInstance().loadField(urlParams.fieldID)
        : undefined
    return { field }
}

const render = ({
    data: { field },
}: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    const params: any = useParams()

    return (
        <>
            {!!field && <FieldPage editField={field} forClient={true} />}
            {!params.fieldID && <FieldPage forClient={true} />}
        </>
    )
}

/** @deprecated - consolidate with FieldPage (unnecessary wrapper component) */
export const ClientFieldPage = usePSComponent(render, viewWillAppear)
